import { Link, useLocation } from "react-router-dom";

const AttendeeStepper = ({ attendees, cancleRequests }) => {
  const location = useLocation();
  const isAttendeeList = location.pathname === "/organizer/attendees";
  const isCancelRequests =
    location.pathname === "/organizer/cancelTicket/requests";

  return (
    <nav className="event-attendees-tabs" aria-label="Attendee views">
      <Link
        className={`event-attendees-tab${isAttendeeList ? " is-active" : ""}`}
        to="/organizer/attendees"
        aria-selected={isAttendeeList}
      >
        Attendee List {attendees >= 0 ? `(${attendees})` : ""}
      </Link>
      <Link
        className={`event-attendees-tab${isCancelRequests ? " is-active" : ""}`}
        to="/organizer/cancelTicket/requests"
        aria-selected={isCancelRequests}
      >
        Cancel Ticket Request{" "}
        {cancleRequests >= 0 ? `(${cancleRequests})` : ""}
      </Link>
    </nav>
  );
};

export default AttendeeStepper;
